import { onMounted, watch } from "vue";

/*
  Bridges a Vue component's load lifecycle to the test harness's
  waitOnViewLoad protocol (see jose_modern/on_view_load.js).

  Call at script-setup time. Increments __viewLoadPending at setup and
  __viewLoadCompleted exactly once when the component is "ready":
    - with no argument: ready at onMounted.
    - with a reactive getter: ready when the getter first reads true
      (either already at mount, or later).
  No-op outside the test env.
*/
export default (loadedGetter) => {
  if (window.railsEnv !== "test") return;

  window.__viewLoadPending = (window.__viewLoadPending || 0) + 1;

  onMounted(() => {
    if (!loadedGetter || loadedGetter()) {
      window.__viewLoadCompleted = (window.__viewLoadCompleted || 0) + 1;
      return;
    }
    const unwatch = watch(loadedGetter, (loaded) => {
      if (loaded) {
        window.__viewLoadCompleted = (window.__viewLoadCompleted || 0) + 1;
        unwatch();
      }
    });
  });
};
